<div class="stt-container">
  <button class="mic-button t-top t-no-arrow" [ngClass]="{'active': isListening, 'speech-active': isSpeechActive, 'speech-ending': isSpeechEnding}" (click)="toggleSpeechRecognition()"
          [attr.data-tooltip]="'MIC_TITLE' | translate"
          [attr.aria-label]="'MIC_TITLE' | translate">
    <span class="mic-icon" role="img" [attr.aria-label]="'MIC_TITLE' | translate"></span>
  </button>
  <div *ngIf="showTooltip" class="mic-tooltip" [ngClass]="{'active': showTooltip}">{{'SPEAK_QUESTION_TOOLTIP' | translate}}</div>
</div>